export default {
  default: {
    access: 'Acceso',
    access_protocol: 'Protocolo de Acceso',
    access_server: 'Access Server',
    account: 'Cuenta',
    account_data: 'Datos de cuenta',
    account_type: 'Tipo de cuenta',
    accumulated_debt: 'Deuda acumulada',
    acs: 'ACS',
    acs_disabled: 'ACS deshabilitado',
    acs_enabled: 'ACS habilitado',
    action: 'Acción',
    actions: 'Acciones',
    activate: 'Activar',
    active: 'Activo',
    active_discounts: 'Activos',
    active_order: 'Orden activa',
    active_recurring_items: 'Items recurrentes activos',
    add: 'Agregar',
    add_column: 'Agregar columna',
    add_column_left: 'Agregar columna a la izquierda',
    add_column_right: 'Agregar columna a la derecha',
    add_credit_card: 'Agregar tarjeta de crédito',
    add_dgo: 'Agregar DGO',
    add_discount: 'Agregar descuento',
    add_urn: 'Agregar URN',
    add_filter: 'Añadir filtro',
    add_forward: 'Agregar redireccionamiento',
    add_forwarded_ports: 'Agregar redireccionamiento de puertos',
    add_item: 'Agregar item',
    add_nested_filter: 'Añadir filtro anidado',
    add_new_field: 'Agregar nuevo campo',
    add_recurring_item: 'Agregar item recurrente',
    add_recurring_item_tax: 'Agregar impuesto',
    add_row: 'Agregar fila',
    add_row_above: 'Agregar fila arriba',
    add_row_below: 'Agregar fila abajo',
    add_seal: 'Agregar precinto',
    add_service: 'Agregar servicio',
    add_tax: 'Agregar impuesto',
    additional_data: 'Datos adicionales',
    address: 'Dirección',
    address_ip: 'Dirección IP',
    addresses: 'Direcciones',
    admin: 'Admin',
    administrative: 'Administrativo',
    administrative_read_only: 'Administrativo de solo lectura',
    administrative_supervisor: 'Supervisor administrativo',
    administrative_supervisor_read_only: 'Supervisor administrativo de solo lectura',
    advanced: 'Avanzado',
    advanced_search: 'Búsqueda Avanzada',
    advanced_search_description_tour:
      'Crea consultas complejas en segundos con nuestro panel de filtros mejorado. Combina varios campos y operadores para encontrar exactamente lo que necesitas.',
    agreement_details: 'Detalles del acuerdo',
    alert_internet: 'Alerta Internet',
    alerted: 'Alertado',
    alerts: 'Alertas',
    all: 'Todas',
    all_invalid_mobile_phones: 'Todos los números de celular inválidos',
    all_periods: 'Todos los periodos',
    all_the: 'todos los',
    allow_blank: 'No puede estar Vacío',
    allow_nil: 'No puede estar Vacío',
    allowed_formats: 'Formatos permitidos',
    amount: 'Monto',
    amount_gteq: 'Monto (Desde)',
    amount_iva: 'Monto IVA',
    amount_lteq: 'Monto (Hasta)',
    amount_with_igv: 'Monto con IGV',
    amount_with_vat: 'Monto con IVA',
    amount_without_iva: 'Monto sin IVA',
    amplitude: 'Amplitud',
    answer: 'Respuesta',
    api: 'API',
    api_credentials: 'API Credenciales',
    api_key: 'API Key',
    api_login: 'API Login',
    api_response: 'Respuesta de API',
    api_ssl_port: 'Puerto API-SSL',
    api_token: 'API Token',
    app_mobile: 'Aplicación Móvil',
    applied: 'Aplicado',
    applied_at: 'Aplicado el',
    applied_lapses: 'Periodos aplicados',
    apply: 'Aceptar',
    apply_discount: 'Aplicar descuento',
    applying: 'Aplicando',
    article: 'Artículo',
    articles: 'Artículos',
    assign: 'Asignar',
    assignable_to: 'Asignado a',
    assigned_type: 'Tipo de asignación',
    assistance: 'Asistencia',
    associated_contracts: 'Contratos asociados',
    attachment: 'Adjunto',
    attachment_not_loaded: 'No se pudo cargar el archivo adjunto.',
    attempts: 'Reintentos',
    attention: 'Atención',
    audit: 'Auditoría',
    audits: 'Auditorías',
    authorize: 'Autorizar',
    authorize_invoice_after_paid: 'Informar después de pagar',
    authorize_ont: 'Autorizar ONU',
    authorized: 'Autorizado',
    authorizing: 'Autorizando',
    authorizing_error: 'Error de autorización',
    auto_confirm: 'Confirmar automáticamente',
    autocomplete_first_free_ip: 'Autocompletar primer IP libre',
    automatic: 'Automático',
    automatic_debit: 'Débito automático',
    automatic_debit_disabled: 'Sin débito automático',
    automatic_debit_enabled: 'Con débito automático',
    automatic_state: 'Estado automático',
    availability: 'Disponibilidad',
    available_credit: 'Crédito disponible',
    available_credit_in_account: 'Crédito disponible en cuenta',
    available_one: 'disponible',
    available_other: 'disponibles',
    available_ports: 'Puertos disponibles',
    available_promises: 'Promesas disponibles',
    avatar: 'Avatar',
    back: 'Volver',
    backups: 'Backups',
    balance: 'Saldo',
    band_2_4_disconnected: 'Banda (2.4Ghz) desconectada',
    band_5_disconnected: 'Banda (5.8Ghz) desconectada',
    bank: 'Banco',
    bank_process_date: 'Fecha de proceso bancario',
    bank_transfer: 'Transferencia bancaria',
    barcode: 'Código de barras',
    base: 'Base',
    base_errors_title: 'Por favor revise los siguientes problemas:',
    basic: 'Básico',
    batch: 'Lote',
    billing_information: 'Datos de facturación',
    billing_regime: 'Regimen de Facturación',
    bmu: 'BMU',
    bmu_id: 'BMU (ID)',
    board: 'Board',
    body: 'Cuerpo',
    both: 'Ambos',
    box_details: 'Detalles del box',
    box_manager: 'Box Manager',
    branch_office: 'Sucursal',
    brand: 'Marca',
    broadcast: 'Broadcast',
    burst: 'Ráfaga',
    by_default: 'Por defecto',
    cable_modem: 'Cable Modem',
    cable_modem_bin_file: 'Cable modem archivo bin',
    cable_modem_enabled: 'Cable modem habilitado',
    cable_modem_gateway: 'Cable modem puerta de enlace',
    cable_modem_ip: 'Cable modem ip',
    cable_modem_mac_address: 'Cable modem mac address',
    cache: 'Cache',
    calendar: 'Calendario',
    cancel: 'Cancelar',
    cancel_selection: 'Anular selección',
    cancel_suscription: 'Cancelar suscripción',
    canceled: 'Cancelado',
    cancelled_amount: 'Monto cancelado',
    cancelled_at: 'Cancelado el',
    cancelled_invoice: 'Factura cancelada',
    cancelled_payment: 'Pago anulado',
    cant_change_server_if_exist_forwarded_ports:
      'No se puede cambiar el servidor si el contrato tiene redirección de puertos',
    cant_change_server_if_exist_full_nat: 'No se puede cambiar de servidor si se tiene asociado a FULL-NAT',
    cant_connect_to_mikrotik: 'No es posible conectarse al mikrotik',
    capacity: 'Capacidad',
    cardnet: 'Cardnet',
    cash: 'Efectivo',
    cash_audit_id: 'Arqueo de Caja (ID)',
    categories: 'Categorías',
    category: 'Categoría',
    cbu_holder: 'CBU de la cuenta',
    ceil_dfl_percent: 'Porcentaje Ceil DFL',
    certificate_updated: 'Certificado actualizado',
    change_password: 'Cambiar contraseña',
    change_ssid: 'Cambiar SSID',
    change_state: 'Cambiar estado',
    change_user: 'Cambiar usuario',
    channel: 'Canal',
    chars_quantity: 'Cantidad de caracteres',
    check: 'Cheque',
    check_service: 'Comprobar servicio',
    choose_a_kind_of_person: 'Seleccione un tipo de persona',
    choose_a_nap_on_the_map: 'Seleccione una NAP en el mapa',
    choose_a_regimen: 'Seleccione un régimen',
    choose_an_invoicing_firm: 'Seleccione una razón social',
    choose_an_invoicing_firm_and_a_kind_invoice: 'Seleccione una razón social y un tipo de factura',
    choose_an_invoicing_firm_and_a_kind_person: 'Seleccione una razón social y un tipo de persona',
    choose_an_option: 'Seleccione una opción',
    choose_substitutions: 'Elegir sustituciones',
    choose_to_invoicing_firm: 'Elige una razón social',
    cir: 'CIR',
    city: 'Ciudad',
    cisco: 'Cisco',
    huawei: 'Huawei',
    clean_errors: 'Limpiar Errores',
    clean_filters: 'Limpiar Filtros',
    clear_search: 'Limpiar búsqueda',
    clear_selection: 'Anular la selección.',
    cleared: 'Resueltas',
    click: 'click aqui',
    client: 'Cliente',
    client_bank: 'Banco del cliente',
    client_bank_name: 'Nombre del banco del cliente',
    client_custom_id: 'ID personalizado de cliente',
    client_email: 'Email del cliente',
    client_id: 'Cliente (ID)',
    client_identification: 'Identificación del cliente',
    client_identification_number: 'Número de identificación del cliente',
    client_info: 'Información del Cliente',
    client_invoicing_disabled: 'El cliente tiene la facturación deshabilitada',
    client_name: 'Nombre del cliente',
    client_not_found: 'Cliente no encontrado',
    client_phone: 'Teléfono del cliente',
    client_phone_number: 'Número teléfono del cliente',
    client_reference: 'Referencia del cliente',
    client_secret: 'Clave secreta',
    clients: 'Clientes',
    clients_with_errors: 'Clientes con errores',
    clients_with_processed: 'Clientes validos',
    close: 'Cerrar',
    close_issue: 'Cerrar Ticket',
    close_massive_update: 'Cerrar actualización masiva',
    close_preview: 'Cerrar previsualización',
    closed: 'Cerrado',
    closed_at: 'Cerrado el',
    cobro_digital: 'Cobro Digital',
    code: 'Código',
    collections: 'Cobranzas',
    collector: 'Recaudador',
    collector_email: 'Email del Recaudador',
    collector_id: 'Recaudador (ID)',
    collector_read_only: 'Recaudador de solo lectura',
    color: 'Color',
    combo_pay: 'Combopay',
    command: 'Comando',
    comment: 'Comentario',
    comments: 'Comentarios',
    common_regime: 'Regimen Común',
    company_id: 'ID Comercio',
    company_name: 'Nombre de Compañia',
    complete_nap: 'NAP completa',
    completed: 'Completado',
    complexity: 'Complejidad',
    concept: 'Concepto',
    config_by_wispro: 'Configurada por Wispro',
    configuration: 'Configuración',
    configurations: 'Configuraciones',
    configure: 'Configurar',
    configure_notifications: 'Configurar notificaciones',
    confirm: 'Confirmar',
    connected: 'Conectado',
    connection_with_wispro: 'Conexión con Wispro',
    connectivity: 'Conectividad',
    consumption_summary: 'Resumen de consumo',
    contact: 'Contacto',
    contact_information: 'Medios de contacto',
    contact_name: 'Nombre del contacto',
    contact_with_support: 'Contacte con soporte',
    contract: 'Contrato',
    contract_delinquent: 'Contrato moroso',
    contract_id: 'Contrato (ID)',
    contract_identifier: 'Contrato N°',
    contracts: 'Contratos',
    contracts_active: '{{count}} contratos activos.',
    contracts_affected: 'Contratos afectados',
    contracts_limit_almost_reached: 'La cantidad máxima de contratos en la suscripción está por alcanzarse.',
    contracts_limit_reached:
      'La cantidad máxima de contratos en la suscripción ha sido alcanzada, por favor actualice su suscripción.',
    contracts_linked: 'Contratos vinculados',
    contracts_to_apply: 'Contratos afectados',
    converter: 'Conversor',
    copied: 'Copiado',
    copied_succesfully: 'Copiado con exito',
    copy: 'Copiar',
    copy_token: 'Copiar TOKEN',
    corporative: 'Corporativo',
    cost: 'Costo',
    could_not_be_sent: 'No se pudo enviar',
    count_applied_lapse: 'Periodos aplicados',
    country: 'País',
    coverage: 'Cobertura',
    coverage_id: 'Nodo Wireless',
    cpe_port: 'Puerto CPE',
    cpe_protocol: 'Protocolo CPE',
    create: 'Crear',
    create_categories: 'Crear categorías',
    create_changelog: 'Crear Changelog',
    create_configuration: 'Crear Configuración',
    create_neighborhood: 'Crear barrio',
    create_new: 'Crear nueva',
    create_new_client: 'Crear nuevo Cliente',
    create_new_profile: 'Crear nuevo perfil',
    create_notification_mobile: 'Crear notificación móvil',
    create_olt: 'Crear OLTs',
    create_payment_promise: 'Crear Promesa de pago',
    create_port_forward: 'Crear redirección de puertos',
    create_ppp_profile: 'Crear perfil PPP',
    create_ticket: 'Crear Ticket',
    create_ticket_and_order: 'Crear Ticket y Orden',
    create_ticket_and_order_feasibility: 'Crear Ticket y Factibilidad',
    create_ticket_and_order_installation: 'Crear Ticket y Instalación',
    create_zone: 'Crear zona',
    created: 'Creado',
    created_at: 'Creado el',
    created_at_between: 'Creado entre (Fechas)',
    created_at_gteq: 'Creado (Desde)',
    created_at_lteq: 'Creado (Hasta)',
    created_by: 'Creado por',
    created_date: 'Fecha de creación',
    creation: 'Creación',
    creator: 'Creador',
    credentials: 'Credenciales',
    credit: 'Crédito',
    credit_card: 'Tarjeta de crédito',
    credit_note: 'Nota de crédito',
    credit_note_create: 'Crear nota de crédito',
    credit_note_edit: 'Editar nota de crédito',
    credit_notes: 'Notas de Credito',
    criteria: 'Criterio',
    critical: 'Críticas',
    critical_interfaces: 'Interfaces críticas',
    critical_ports: 'Puertos críticos',
    csv_file: 'Archivo CSV',
    cuenta_digital: 'Cuenta Digital',
    cuit_holder: 'CUIT del Titular de la cuenta',
    current_account: 'Cuenta corriente',
    current_amount_with_igv: 'Monto con IGV actual',
    current_amount_with_vat: 'Monto con IVA actual',
    current_credit_note_number_voucher: 'Último num. de nota de credito Comprobante',
    current_discount: 'Descuento actual',
    current_discount_scale: 'Escala de descuentos actual',
    current_discounts: 'Descuentos activos',
    current_file_number: 'Número secuencial ascendente único por archivo',
    current_invoice_number_voucher: 'Último num. de factura Comprobante',
    current_revenue_share: 'Comisión actual',
    custom_id: 'ID Personalizado',
    custom_netmask: 'Máscara de red',
    custom_payment: 'Pago personalizado',
    customizable_client_id: 'ID Cliente personalizable',
    //Estas keys se crearon para rails provisoriamente
    customizable_identifier: 'ID Cliente personalizable',
    customizeNews: 'Personalizar novedades',
    cycle: 'Ciclo',
    data: 'Datos',
    date: 'Fecha',
    date_processed: 'Fecha del pago',
    day: 'día',
    days: 'días',
    days_of_service: 'Días de servicio',
    deactivate: 'Desactivar',
    debit: 'débito',
    debit_card: 'Tarjeta de débito',
    degraded: 'Degradado',
    delete: 'Eliminar',
    delete_all: 'Borrar todo',
    delete_column: 'Eliminar columna',
    delete_discount: 'Eliminar descuento',
    delete_record: 'Eliminar Historial',
    delete_records: 'Eliminar registros',
    delete_recurring_item: 'Eliminar item recurrente',
    delete_row: 'Eliminar fila',
    delete_service: 'Eliminar servicio',
    delete_tax: 'Eliminar impuesto',
    deleted: 'Eliminado',
    deleted_at: 'Eliminado el',
    deleted_at_gteq: 'Eliminado (Desde)',
    deleted_at_lteq: 'Eliminado (Hasta)',
    deleted_payment: 'Pago borrado',
    deleting: 'Eliminando',
    delimiter: 'Separador',
    delinquent: 'Moroso',
    description: 'Descripción',
    deselect_all: 'Deseleccionar todos.',
    destination_number: 'Número Destino',
    destroy: 'Eliminar',
    detail: 'Detalle',
    details: 'Detalles',
    device: 'Dispositivo',
    device_id: 'Dispositivo (ID)',
    device_name: 'Nombre de Dispositivo',
    device_signal: 'Señal del dispositivo',
    devices: 'Dispositivos',
    dgo: 'DGO',
    dgo_pack: 'Pack DGO',
    dhcp: 'DHCP',
    dhcp_enabled: 'Habilitar DHCP',
    dhcp_mac_address: 'Dirección MAC DHCP Relay',
    dhcp_server: 'Servidor DHCP',
    dhcpv6_pd_pool: 'DHCPv6 PD Pool',
    disable: 'Deshabilitado',
    disable_automatic_sending: 'Desactivar envío automático',
    disabled: 'Deshabilitado',
    disabled_contract: 'Contrato deshabilitado',
    disabling: 'Deshabilitar',
    discharge_date: 'Fecha de alta',
    disconnected: 'Desconectado',
    discount: 'Descuento',
    discount_amount: 'Monto de descuento',
    discount_applied: 'Descuento Aplicado',
    discount_management: 'Gestión de descuentos',
    discount_percentage: 'Descuento (%)',
    discount_scale: 'Escala de descuentos',
    discounts: 'Descuentos',
    dns: 'DNS',
    dns_one: 'Primer DNS',
    dns_servers: 'Servidores DNS',
    dns_two: 'Segundo DNS',
    documents: 'Documentos',
    domain: 'Dominio',
    done: 'Hecho',
    download: 'Descargar',
    download_afip_certificate: 'Descargar pedido para solicitar certificado',
    download_count_rows_one: 'Descargar {{count}} fila',
    download_count_rows_other: 'Descargar {{count}} filas',
    download_csv: 'Descargar CSV',
    download_dataset: 'Descarga de set de datos',
    download_invoice: 'Descargar factura',
    download_successful: 'Descarga exitosa',
    download_xls: 'Descargar en Excel',
    draft: 'Borrador',
    drag_and_drop_files_or_click: 'Arrastra y suelta archivos, o haz clic para seleccionar',
    drag_elements_here: 'Arrastre elementos aquí',
    drop_files_here: 'Suelta los archivos aquí...',
    due_date: 'Vencimiento',
    due_dates: 'Vencimientos',
    duplicate_column: 'Duplicar columna',
    edit: 'Editar',
    edit_isp: 'Editar ISP',
    edit_massive_update: 'Editar actualización masiva',
    edition: 'Edición',
    edition_data: 'Data de edición',
    efecty: 'Efecty',
    electronic: 'Electrónica',
    electronic_enabled: 'Facturación electrónica',
    electronic_invoice: 'Facturación electrónica',
    electronic_invoicing_firm_unvalidated: 'Razón Social electrónica no verificada',
    electronic_invoicing_firm_validated: 'Razón Social electrónica verificada',
    electronic_payment_code: 'Código de pago electrónico',
    electronic_transfer: 'Transferencia electrónica',
    electronic_validated: 'Cuenta electrónica validada',
    electronic_verify: 'Verificación electrónica',
    email: 'Email',
    emails_to_notify: 'Emails a notificar',
    empty_label: 'No hay coincidencias',
    empty_list: 'Lista Vacía',
    emptystring: '',
    enable_automatic_sending: 'Activar envío automático',
    enabled: 'Habilitado',
    enabling: 'Habilitar',
    encoding: 'Encoding',
    english: 'Inglés',
    enter_address: 'Ingresar Dirección',
    erasable: 'Borrable',
    error: 'Error',
    error_generate_authorization_invoices: 'Hubo un error generando el set de datos',
    error_type: 'Típo de Error',
    errors: 'Errores',
    event: 'Evento',
    example: 'Ejemplo',
    exclude: 'Excluir',
    expiration_date: 'Fecha de expiración',
    expire: 'Expirar',
    expire_at: 'Vence el',
    expired: 'Expirada',
    expires_at: 'Vence el',
    export: 'Exportar',
    export_all: 'Exportar todos los',
    export_cash_audits: 'Exportar Arqueos de Caja',
    export_classic: 'Exportar Contratos con estructura de classic',
    export_classic_entry: 'Exportar Classic',
    export_clients: 'Exportar Clientes',
    export_contracts: 'Exportar Contratos',
    export_contracts_with_price: 'Exportar Contratos con precios',
    export_credit_notes: 'Exportar Notas de Crédito',
    export_csv: 'Exportar a CSV',
    export_installation_orders: 'Exportar Órdenes de instalación',
    export_invalid_mobile_phone_numbers: 'Exportar números de celular inválidos',
    export_invoices: 'Exportar Facturas',
    export_olts: 'Exportar OLTs',
    export_only_filtered: 'Exportar solo los filtrados',
    export_only_filtered_csv: 'Exportar los filtrados a CSV',
    export_only_filtered_xls: 'Exportar los filtrados a Excel',
    export_payments: 'Exportar Pagos',
    export_png: 'Exportar a PNG',
    export_xls: 'Exportar a Excel',
    exporter: 'Exportador',
    exporting: 'Exportando',
    exports: 'Exportaciones',
    external_technician: 'Técnico externo',
    extra_vlans: 'Extra VLANS',
    extras: 'Extras',
    facilito: 'Facilito',
    failed_at: 'Falló el',
    failure: 'Fallo',
    fantasy: 'Fantasia',
    fbp: 'FBP',
    feature_preview: 'Vista previa de funcionalidades',
    feedback: 'Feedback',
    feedback_id: 'ID Feedback',
    feedback_kind: 'Tipo de Feedback',
    feedback_kinds: 'Tipos de Feedback',
    feedbacks: 'Feedbacks',
    file_for_import: 'Archivo para importación',
    filter: 'Filtro',
    filter_in_table: 'Filtrar en tabla',
    filter_name: 'Nombre del filtro',
    filter_search: 'Busqueda con Filtros',
    filtered_records: 'Registros filtrados',
    filtering: 'Filtrado',
    filters: 'Filtros',
    final_price: 'Precio Final',
    finalized: 'Finalizado',
    finalized_at: 'Finalizado el',
    finalized_issue: 'Problema finalizado',
    find_transactions: 'Buscar transacciones',
    finished_discounts: 'Finalizados',
    firmware_model: 'Firmware Modelo',
    first: 'Primero',
    first_last_name: 'Primer apellido',
    //Estas keys se crearon para rails provisoriamente
    first_name: 'Primer nombre',
    first_number: 'Primer número',
    fiscal_info: 'Información Fiscal',
    fixed_amount: 'Monto fijo',
    forwarded_ports: 'Redirecciones de Puerto',
    frame: 'Frame',
    frecuency: 'Frecuencia',
    from: 'de',
    full_nat: 'FULL-NAT',
    gateway: 'Puerta de Enlace',
    general: 'General',
    general_info: 'Información general',
    general_information: 'Información general',
    general_manager: 'Manager general',
    general_manager_read_only: 'Manager general de solo lectura',
    generate_invoice_every_day: 'Generar factura cada día',
    generate_transaction: 'Generar transacción',
    generic: 'Generico',
    geolocation: 'Geolocalización',
    go_to: 'Ir a',
    go_to_basic_search: 'Ir a búsqueda Básica',
    go_to_documentation: 'Ir a la documentación',
    go_to_googlemaps: 'Ir a Google Maps',
    go_to_license: 'Ir a licencia',
    go_to_olt: 'Ir a OLT',
    go_to_the_documentation: 'Ir a la documentación',
    gpon_navigator: 'Navegador GPON',
    gpon_ports: 'Puertos GPON',
    gpon_ports_in_use: '{{count}} Puertos GPON en uso.',
    greater_than: 'Mayor que',
    greater_than_or_equal_to: 'Mayor o igual a',
    gross_amount: 'Monto Bruto',
    gross_income: 'Ingresos brutos',
    has_active_filters: 'Tiene filtros activos',
    hashtag: '#',
    have_selected: 'Has seleccionado',
    helpdesk: 'Mesa de ayuda',
    helpdesk_read_only: 'Mesa de ayuda de solo lectura',
    helpdesk_supervisor: 'Supervisor de mesa de ayuda',
    helpdesk_supervisor_read_only: 'Supervisor de mesa de ayuda de solo lectura',
    here: 'aquí',
    hide: 'Ocultar',
    hide_details: 'Ocultar Detalles',
    high: 'Alto',
    home: 'Inicio',
    hour: 'Hora',
    hours: 'Horas',
    how_to_use_composal_download: 'Como usar la descarga',
    how_to_use_composal_export: 'Como usar la exportación',
    how_to_use_it: 'Como usarlo',
    how_to_use_massive_update: 'Como usar la actualización masiva',
    id: 'ID',
    identifiers: 'Identificadores',
    image: 'Imagen',
    images: 'Imágenes',
    import: 'Importar',
    import_aliases_cbu_siro: 'Importar Alias/CBU (Siro)',
    import_payments: 'Importar pagos',
    import_statuses: 'Importar Estados',
    importer: 'Importador',
    in_use: 'En uso',
    inactive: 'Inactivo',
    inactive_recurring_items: 'Items recurrentes inactivos',
    include: 'Incluir',
    include_all_periods: 'Incluir todos los periodos',
    included_in: 'Incluida en',
    indicators: 'Indicadores',
    informing: 'Informando',
    instagram_quantity: 'Cantidad de Instagram',
    installation: 'Instalación',
    installation_orders: 'Ordenes de instalación',
    installation_price: 'Precio de instalación',
    installer: 'Instalador',
    installer_read_only: 'Instalador de solo lectura',
    installer_supervisor: 'Supervisor de instalaciones',
    installer_supervisor_read_only: 'Supervisor de instalaciones de solo lectura',
    interest: 'Interés',
    interests: 'Intereses',
    interface: 'Interfaz',
    interface_not_belongs_to_server: 'La interfaz no pertenece al servidor del contrato',
    interfaces: 'Interfaces',
    internal_use: 'Uso interno',
    invalid_api_key: 'API Key invalida',
    invalid_merchant_abrev: 'Merchant abrev inválido',
    invalid_token: 'Token Inválido',
    inventory_articles: 'Inventario de Articulos',
    invoice: 'Factura',
    invoice_create: 'Crear factura',
    invoice_details: 'Detalles de factura',
    invoice_edit: 'Editar factura',
    invoice_from: 'Factura de',
    invoice_number: 'Número de factura',
    invoice_payments: 'Pagos de la Factura',
    invoice_provider: 'Proveedor de facturación',
    invoice_title: '{{kind_invoice}} de {{firm_company_name}} ({{firm_vat_condition}})',
    invoiced: 'Facturado',
    invoiced_at: 'Facturado el',
    invoices: 'Facturas',
    invoicing: 'Facturación',
    invoicing_client: 'Facturación del cliente',
    invoicing_client_id: 'Cliente (ID Facturación)',
    invoicing_contract_id: 'Contrato (ID Facturación)',
    invoicing_disabled: 'Facturación deshabilitada',
    invoicing_discount_id: 'Descuento',
    invoicing_enabled: 'Facturación habilitada',
    invoicing_errors: 'Errores de facturación',
    invoicing_firm: 'Razón Social',
    invoicing_firm_id: 'Razón Social (ID Facturación)',
    invoicing_firms: 'Razones Sociales',
    invoicing_info: 'Información de Facturación',
    invoicing_information: 'Informacion de facturación',
    invoicing_invoice: 'Factura',
    invoicing_isp_id: 'ISP (ID Facturación)',
    invoicing_module: 'Módulo de Facturación',
    invoicing_name: 'Nombre de factura',
    invoicing_payment: 'Pago',
    invoicing_plan_attributes: {
      frecuency: 'Frecuencia',
      price: 'Precio',
      product_code: 'Código de producto'
    },
    invoicing_profile: 'Perfil de facturación',
    invoicing_profile_id: 'Perfil de facturación',
    invoicing_state: 'Estado de facturación',
    invoicing_summary: 'Resumen de facturación',
    ip: 'IP',
    ip_address: 'Dirección IP',
    ip_mode: 'Modo IP',
    isp: 'ISP',
    isp_id: 'ISP (ID)',
    isp_name: 'Nombre del ISP',
    issue: 'Ticket',
    issue_invoice: 'Emitir factura',
    issued_at: 'Emitido el',
    issued_at_date: 'Fecha de emisión',
    issued_invoice: 'Factura emitida',
    issues: 'Tickets',
    item: 'Ítem',
    item_taxes: 'Impuestos',
    items: 'Items',
    kind: 'Tipo',
    kind_invoice: 'Tipo de factura',
    kind_person: 'Tipo de persona',
    kind_subscription: 'Tipo de suscripción',
    language: 'Lenguaje',
    lapses: 'Periodos',
    last: 'Último',
    last_4_digits: 'Últimos 4 dígitos',
    last_digits: 'ultimos {{count}} digitos',
    last_name: 'Apellido',
    last_number: 'Último número',
    last_payments: 'Últimos pagos',
    last_transaction: 'Última transacción',
    last_update: 'Última actualización',
    last_used_number: 'Último número usado',
    latitude: 'Latitud',
    layout: 'Plantilla',
    lead: 'Lead',
    lead_info: 'Información del Lead',
    lead_name: 'Nombre del Lead',
    less_than: 'Menor que',
    less_than_or_equal_to: 'Menor o igual a',
    level: 'Nivel',
    license: 'Licencia',
    limits: 'Limites',
    link: 'Enlace',
    link_ont: 'Vincular',
    link_payments: 'Link de pagos',
    link_with_ont: 'Asociar con ONU',
    linked: 'Vinculado',
    linked_contracts: 'Contratos vinculados',
    linked_female: 'Vinculada',
    linked_male: 'Vinculado',
    load_again: 'Volver a cargar',
    loading: 'Cargando',
    loading_new_info: 'Cargando nueva información',
    local_address: 'Dirección local',
    locality: 'Localidad',
    location: 'Ubicación',
    location_data: 'Datos de ubicación',
    location_id: 'ID de Ubicación',
    location_type: 'Tipo de ubicación',
    locations: 'Localizaciones',
    locked_at: 'Bloqueado el',
    longitude: 'Longitud',
    low: 'Bajo',
    mac_address: 'Dirección MAC',
    mac_address_relay: 'MAC Address Relay',
    no_mac_address: 'Sin MAC',
    major: 'Mayores',
    manual: 'Manual',
    manual_notifications: 'Notificaciones Manuales',
    manual_payments_import: 'Importar pagos manual',
    manuals: 'Manuales',
    map: 'Mapa',
    mark_as_viewed: 'Marcar como visto',
    massive_actions: 'Acciones masivas',
    massive_destroy: 'Eliminar masivamente',
    massive_update: {
      massively_update: 'Actualizar masivamente',
      mikrotik_interface_id: 'Interfaz Mikrotik (ID)',
      plan_id: 'Plan (ID)'
    },
    massive_update_confirm: 'Confirmar Actualización masiva',
    max_download: 'Máx. bajada',
    max_upload: 'Máx. subida',
    medium: 'Medio',
    mercado_pago: 'Mercado Pago',
    messenger_quantity: 'Cantidad de Messenger',
    metrics: 'Métricas',
    mi_vecino: 'Mi vecino',
    migrator: 'Migrador',
    mikropipi: 'Mikropipi',
    mikrotik: 'Mikrotik',
    accessserver: 'Access Server',
    mikrotik_configuration: 'Configuración Mikrotik',
    mikrotik_interface_id: 'Interfaz Mikrotik',
    mikrotik_not_linked: 'Mikrotik no vinculado',
    mikrotik_use_ssl: 'API-SSL',
    minor: 'Menores',
    minute: 'Minuto',
    minutes: 'Minutos',
    missing_key: 'Falta traducción',
    missing_substitution: 'Falta sustitución',
    mobile: 'Móvil',
    mobile_phone: 'Teléfono móvil',
    //Estas keys se crearon para rails provisoriamente
    mobile_phone_number: 'Teléfono celular',
    mode: 'Modo',
    model: 'Modelo',
    models: '{{models}}',
    module: 'Módulo',
    month: 'mes',
    months: 'meses',
    more_actions: 'Más acciones',
    more_info: 'Más Información',
    multiple_clients_by_reference: 'Múltiples referencias',
    name: 'Nombre',
    nap: 'NAP',
    nap_id: 'NAP (ID)',
    nap_map: 'Mapa de nap',
    nap_port: 'Puerto NAP',
    naps: 'NAPs',
    naps_in_use: '{{count}} NAPs en uso.',
    nas: 'NAS',
    nas_disabled: 'NAS deshabilitado',
    nas_enabled: 'NAS habilitado',
    national_identification_number: 'Documento o Cédula de identidad',
    neighborhood: 'Barrio',
    neighborhood_id: 'Barrio (ID)',
    neighborhoods: 'Barrios',
    nested_filters: 'Filtros anidados',
    net_amount: 'Monto Neto',
    netmask: 'Máscara de red',
    network: 'Red',
    new: 'Nuevo',
    new_password: 'Nueva contraseña',
    new_payment: 'Nuevo pago',
    new_ssid: 'Nuevo SSID',
    news: 'Novedades',
    next: 'Siguiente',
    next_amount: 'Próximo monto con IVA',
    next_amount_with_igv: 'Próximo monto con IGV',
    next_discount: 'Próximo descuento',
    next_discount_scale: 'Próxima escala de descuentos',
    next_invoices: 'Próximas facturas',
    next_periods: 'Próximos periodos',
    next_revenue_share: 'Próxima comisión',
    no: 'No',
    no_active_order: 'Sin orden activa',
    no_audits: 'Sin auditorias',
    no_details: 'Sin detalles',
    no_device_notifications: 'Sin notificaciones de dispositivos',
    no_devices: 'Sin dispositivos',
    no_errors_found: 'No se encontraron errores',
    no_geolocation: 'Sin Geolocalización',
    no_linked: 'No vinculado',
    no_matches_found: 'No hay coincidencias',
    no_more_discount: 'No hay más descuentos',
    no_options: 'No hay opciones',
    no_payment_gateways: 'Sin pasarelas de pagos',
    no_pg_verified: 'No hay pasarelas de pago verificadas',
    no_port_forwarding: 'Sin redirecciones de puerto',
    no_published_at: 'Sin fecha de publicación',
    no_records: 'Sin registros',
    no_results_found: 'No se encontraron resultados',
    no_rows_to_process: 'No hay filas para procesar',
    no_transactions: 'Sin Transacciones',
    no_verified_payment_gateways: 'Sin pasarelas de pago verificadas',
    node: 'Nodo',
    node_id: 'Nodo (ID)',
    nodes: 'Nodos',
    not_associated_with_any_nap_box: 'No está asociado a ninguna caja NAP',
    not_authorized: 'No autorizado',
    not_be_invoiced: 'No facturar',
    not_dispatched: 'Aún no enviado',
    not_linked: 'No Vinculado',
    not_linked_female: 'No Vinculada',
    not_linked_male: 'No Vinculado',
    not_present: 'No presente',
    not_seen: 'No visto',
    not_specified: 'No especificado',
    notificable_id: 'ID notificable',
    notificable_type: 'Type notificable',
    notification: 'Notificación',
    notification_devices: 'Notificación de dispositivos',
    notification_sms_id: 'ID de notificación sms',
    notifications: 'Notificaciones',
    notifications_sms: 'Notificaciones SMS',
    notify: 'Notificar',
    now: 'Ahora',
    ntp: 'NTP',
    number: 'Número',
    object: 'Objeto',
    observations: 'Observaciones',
    of: 'de',
    offline: 'Desconectados',
    offline_female: 'Desconectada',
    offline_male: 'Desconectado',
    ok: 'OK',
    olt: 'OLT',
    olt_id: 'OLT',
    olt_model: 'Modelo de la OLT',
    olt_stats: 'OLT Stats',
    olts: 'OLTs',
    online: 'Conectados',
    online_female: 'Conectada',
    online_male: 'Conectado',
    online_payment: 'Pago online',
    only_integer: 'Solo valor número',
    ont: 'ONU',
    ont_authorized_not_linked: 'Autorizada no vinculada',
    ont_not_authorized: 'No autorizada',
    ont_signal: 'Señal ONU',
    onts: 'ONUs',
    onu: 'ONU',
    onu_contracts_signals: 'Señal de contratos con ONU',
    onu_reboot: 'Reiniciar ONU',
    open_massive_update: 'Abrir actualización masiva',
    optical_fiber: 'Fibra óptica',
    order: 'Orden',
    order_configurations: 'Configuraciones de Órdenes',
    order_name: 'Nombre de orden',
    order_parameters: 'Parámetros de Órdenes',
    osis_no_records: 'No hay redes para mostrar',
    other: 'Otro',
    others: 'Otros',
    owner: 'Dueño',
    pagoralia: 'Pagoralia',
    paid: 'Pagada',
    paid_amount: 'Monto pagado',
    parameters: 'Parámetros',
    password: 'Contraseña',
    pay: 'Pagar',
    pay_u: 'PayU',
    pay_with: 'Pagar con',
    payment: 'Pago',
    payment_associated_with: 'Pago asociado a',
    payment_cancellation: 'Anulacion de pago',
    payment_date: 'Fecha de pago',
    payment_details: 'Detalles de pago',
    payment_gateway: 'Pasarela de pago',
    payment_gateways: 'Pasarelas de pago',
    payment_in_exchange_currency: 'Pago en moneda de cambio',
    payment_method: 'Método de pago',
    payment_methods: 'Métodos de pago',
    payment_number: 'N° de pago',
    payment_promise: 'Promesa de pago',
    payment_promises: 'Promesas de pago',
    payment_qr: 'QR de pago',
    payment_receipt: 'Comprobante de pago',
    payment_transactions: 'Transacciones del pago',
    payment_way: 'Forma de pago',
    payments: 'Pagos',
    pcq_with_queue_tree: 'PCQ con árbol de colas',
    pcq_with_simple_queue: 'PCQ con colas simples',
    pending: 'Pendiente',
    pending_verification_by_support: 'Verificación pendiente por soporte',
    percentage: 'Porcentaje',
    perform_conversion: 'Realizar conversión',
    period: 'Periodo',
    period_invoiced: 'Periodo facturado',
    periods: 'Periodos',
    permissions: 'Permisos',
    personal_information: 'Datos personales',
    phone: 'Teléfono',
    phone_mobile: 'Teléfono móvil',
    phone_number: 'Teléfono fijo',
    phones: 'Teléfonos',
    pichincha: 'Pichincha',
    ping: 'Ping',
    plan: 'Plan',
    plan_details: 'Detalles del Plan',
    plan_id: 'Plan (ID)',
    plan_name: 'Nombre del plan',
    plantilla: 'Plantilla',
    pool_numbers: 'Numeración',
    port: 'Puerto',
    port_disabled: 'Deshabilitar puerto',
    port_enabled: 'Habilitar puerto',
    ports: 'Puertos',
    ports_redirect_vpn: 'Puertos a redireccionar vía VPN',
    power_limit: 'Potencia de referencia',
    ppp_profile: 'Perfil PPP',
    ppp_profile_id: 'Perfil PPP (ID)',
    ppp_profiles: 'Perfiles PPP',
    pppoe: 'PPPoE',
    pppoe_enabled: 'Habilitar PPPoE',
    pppoe_password: 'PPPoE Password',
    pppoe_server: 'PPPoE Server',
    pppoe_server_name: 'PPPoE Server Name',
    pppoe_status: 'PPPoE Status',
    pppoe_username: 'PPPoE Username',
    prefix: 'Prefijo',
    presence: 'Es requerido',
    present: 'Presente',
    preview: 'Previsualizar',
    preview_pool_numbers: 'Previsualizar pool numbers',
    previous: 'Anterior',
    price: 'Precio',
    price_per_day: 'Precio/Días',
    principal_activity: 'Actividad principal',
    print: 'Imprimir',
    print_pos: 'Imprimir (POS)',
    priority: 'Prioridad',
    prisma: 'Prisma',
    process_transaction_in_wispro: 'Procesar transacción en Wispro',
    processed: 'Procesado',
    processed_at: 'Procesado el',
    processing: 'Procesando',
    product: 'Producto',
    product_code: 'Código de producto',
    profile: 'Perfil',
    profile_name: 'Nombre de perfil',
    profiles: 'Perfiles',
    prospect: 'Prospecto',
    provider: 'Proveedor',
    provider_group: 'Grupo de proveedores',
    //Estas keys se crearon para rails provisoriamente
    province_state_region: 'Provincia/Estado/Región',
    public: 'Público',
    public_address: 'Dierección pública',
    public_for_mobile: 'Visible para la aplicación móvil',
    public_ip: 'IP pública',
    publish: 'Publicar',
    published: 'Publicado',
    published_at: 'Publicado el',
    publishing: 'Publicando',
    push_token: 'Push token',
    qr_enabled: 'QR habilitado',
    quality_service: 'Calidad del servicio',
    quantity: 'Cantidad',
    question: 'Pregunta',
    quick_search: 'Búsqueda rápida',
    quick_search_description_tour:
      'Filtra al instante tus {{model}}, olvídate de desplazamientos interminables. Esta nueva búsqueda rápida hace que tus consultas diarias sean ultrarrápidas.',
    radius: 'Radius',
    radius_disabled: 'Radius deshabilitado',
    radius_enabled: 'Radius habilitado',
    re_subscribe: 're-suscribir',
    reactivate: 'Reactivar',
    reactivate_account: 'Reactivar Cuenta',
    receiver: 'Receptor',
    reconfig: 'Reescribir configuración',
    reconnection: 'Reconexión',
    reconnection_charge: 'Cargo de reconexión',
    recurring: 'Recurrente',
    recurring_item: 'Item Recurrente',
    recurring_items: 'Items recurrentes',
    reference: 'Referencia',
    reference_prefix: 'Prefijo de referencia',
    refresh_errors: 'Actualizar errores',
    refund: 'Reembolso',
    regenerate_password: 'Regenerar contraseña',
    registered_at: 'Dado de alta el',
    registered_vat_payer: 'Responsable Inscripto',
    rejected_files: 'Archivos rechazados',
    related: 'Relacionado',
    reload: 'Recargar',
    reload_form: 'Recargar Formulario',
    reload_page: 'Recargar página',
    remote_address: 'Dirección remota',
    remove_pack: 'Quitar Plan',
    remove_payment_gateway: 'Eliminar pasarela de pago',
    remove_selection: 'Quitar selección',
    remove_zone: 'Eliminar zona',
    remove_zones: 'Eliminar zonas',
    rename: 'Renombrar',
    replace: 'Reemplazar',
    replace_cells_for: 'Reemplazar celdas por',
    replicas: 'Réplicas',
    report_transaction: 'Reportar transacción',
    request_timeout: 'Solicitud expirada por tiempo de espera',
    required: 'Requerido',
    reset: 'Restablecer',
    reset_user: 'Restablecer usuario',
    restore: 'Restaurar',
    resubscribe: 'Re-suscribirse',
    retry: 'Reintentar',
    retry_connection_with_the_olt: 'Reintentar conexión con la Olt',
    revenue: 'Comisión',
    revenue_share: 'Comisión',
    rif: 'RIF',
    role: 'Rol',
    roles: 'Roles',
    rx_critical: 'Critical',
    rx_optimal: 'Óptimo',
    rx_warning: 'Warning',
    sale: 'Venta',
    sale_desk: 'Mesa de ventas',
    sale_desk_read_only: 'Mesa de ventas de solo lectura',
    sale_desk_supervisor: 'Supervisor de Mesa de ventas',
    sale_desk_supervisor_read_only: 'Supervisor de Mesa de ventas de solo lectura',
    sale_point: 'Punto de venta',
    satellite: 'Satélite',
    save: 'Guardar',
    save_active_filters: 'Guardar filtros activos',
    saved_filters: 'Filtros guardados',
    saved_records_list: 'Lista de registros guardados',
    scheduled_at: 'Programado el',
    seal: 'Precinto',
    seal_code: 'Código de precinto',
    seal_id: 'Precinto (ID)',
    search: 'Buscar',
    search_by_address_ip: 'Buscar por dirección IP',
    search_by_channel_name: 'Buscar por nombre de canal',
    search_by_client_custom_id: 'Buscar por ID personalizado de cliente',
    search_by_client_name: 'Buscar por nombre de cliente',
    search_by_code: 'Buscar por código',
    search_by_fbp_name: 'Buscar por nombre de FBP',
    search_by_id: 'Buscar por ID',
    search_by_invoicing_profile: 'Buscar por perfil de facturación',
    search_by_lead_name: 'Buscar por nombre de lead',
    search_by_name: 'Buscar por nombre',
    search_by_nap_name: 'Buscar por nombre de NAP',
    search_by_olt_name: 'Buscar por nombre de OLT',
    search_by_ont_serial_number: 'Buscar por número de serie ONU',
    search_by_order_name: 'Buscar por nombre de orden',
    search_by_plan_name: 'Buscar por nombre de plan',
    search_criteria: 'Criterios de búsqueda',
    search_engine: 'Buscador',
    search_templates: 'Buscar plantilla',
    search_transaction: 'Buscar transacción',
    second_last_name: 'Segundo apellido',
    second_name: 'Segundo nombre',
    see: 'Ver',
    see_client_details: 'Ver detalles del cliente',
    see_credit_note_detail: 'Ver detalle de la nota de credito',
    see_invoice_detail: 'Ver detalle de la factura',
    see_less: 'Ver menos',
    see_more: 'Ver más',
    see_payment_detail: 'Ver detalle del pago',
    see_token: 'Visualizar TOKEN',
    seen: 'Visto',
    select_a_date: 'Seleciona una fecha',
    select_a_model: 'Seleccione un modelo',
    select_a_option: 'Seleccione una opción',
    select_a_template: 'Selecciona una plantilla',
    select_all: 'Seleccionar {{number}} {{model}}',
    select_an_option: 'Seleccione una opción',
    select_channel_and_template: 'Seleccionar Canal y Template',
    select_for_bulkactions: 'Selecciona para acciones masivas',
    select_option: 'Seleccione una opción',
    select_payment_qr: 'Seleccionar QR de pago',
    select_template_channel_title: 'Selecciona un template y un canal para tu notificación',
    self_assigned_by_olt: 'Autoasignado por la OLT',
    self_employed_taxpayer: 'Responsable Monotributo',
    seller: 'Vendedor',
    seller_id: 'Vendedor (ID)',
    seller_read_only: 'Vendedor de solo lectura',
    send_by_email: 'Enviar por email',
    send_email_when_create_payment: 'Enviar correo cuando se crea un pago',
    send_email_when_issue_invoices: 'Enviar correo con factura emitida',
    sending: 'Enviando',
    sent: 'Enviado',
    sent_at: 'Enviado el',
    sent_by: 'Enviado por',
    sent_date: 'Fecha de envío',
    sent_sms: 'SMS Enviados',
    sent_to: 'Enviado a',
    sequential_id: '#',
    serial: 'Serial',
    server: 'Servidor',
    server_acs: 'Server ACS',
    server_configuration_not_linked: 'Servidor no vinculado',
    servers: 'Servidores',
    service: 'Servicio',
    service_card: 'Tarjeta de servicio',
    service_dgo: 'Servicio Directv Go',
    services: 'Servicios',
    setup_automatic_notifications: 'Configurar notificaciones automáticas',
    shipping_details: 'Detalles de envío',
    show: 'Ver',
    show_alerts: 'Ver alertas',
    show_all: 'Mostrar Todo',
    show_contracts: 'Mostrar Contratos',
    show_details: 'Mostrar detalles',
    show_filters: 'Mostrar filtros',
    show_hide_columns: 'Mostrar/Ocultar Columnas',
    show_info: 'Ver información',
    show_less: 'Mostrar menos',
    show_more: 'Mostrar más',
    show_naps: 'Mostrar NAPs',
    show_preview: 'Mostrar Previsualización',
    show_seals: 'Mostrar Precintos',
    showing: 'Mostrando',
    showing_all: 'Mostrando Todo',
    signal: 'Señal',
    signal_quality: 'Calidad de la señal',
    signature: 'Firma',
    siigo_configuration: 'Configuración de Siigo',
    siigo_credit_note_document_type: 'Comprobante de nota de credito',
    siigo_invoice_document_type: 'Tipo de comprobante de factura',
    siigo_product: 'Producto/Servicio',
    simple_queue: 'Colas simples',
    since: 'Desde',
    siro: 'Siro',
    siro_customer_id: 'Nro. Cliente de SIRO',
    six_months: 'Consumo de los ultimos 6 meses',
    skype: 'Skype',
    sms: 'SMS',
    sms_vendor_id: 'SMS ID',
    social_stratum: 'Estrato social',
    something_went_wrong: 'Opps, Ocurrió un error Inténtelo de nuevo o contacté a soporte',
    sorry_service_unavailable: 'Disculpe, servicio no disponible',
    sort_by: 'Ordenar por',
    source: 'Origen',
    spanish: 'Español',
    speed: 'Velocidad',
    speed_test: 'Prueba de velocidad',
    ssid: 'SSID',
    stack: 'Stack',
    start_activities_date: 'Inicio de actividades',
    start_chat: 'Iniciar chat',
    start_date: 'Fecha de alta',
    start_invoicing_date: 'Fecha inicio facturación',
    start_invoicing_day: 'Ciclo de facturación comienza el día',
    started_at: 'Iniciado el',
    state: 'Estado',
    statistics: 'Estadistica',
    stats: 'Estadísticas (Gráficas)',
    status: 'Estado',
    strategy: 'Estrategia',
    street: 'Calle',
    street_number: 'Número de calle',
    subdomain: 'Subdominio',
    subject: 'Asunto',
    submit: 'Enviar',
    subscribe: 'Suscribirse',
    subscription: 'Suscripción',
    subscriptions: 'Suscripciones',
    substitutions: 'Sustituciones',
    subtotal: 'Subtotal',
    success: 'Exitoso',
    successful_connection: 'Conexión exitosa',
    suffix: 'Sufijo',
    support: 'Soporte',
    support_hola_suite_text: '¡Hola! Estamos aquí para ayudarte. Comienza a chatear con nuestro equipo de soporte.',
    support_hola_suite_trial_license:
      'Estimado cliente, el soporte en línea solo está habilitado para las suscripciones activas.<1></1><2></2>En su caso, debería solicitar asistencia a su asesor comercial o nos puede enviar un mail a: <4>asistencia-offline@wispro.co</4><5></5><6></6>¡Muchas Gracias!',
    support_online: 'Soporte en Línea',
    surcharges: 'Recargos',
    survey: 'Encuesta',
    system: 'Sistema',
    synchronize: 'Sincronizar',
    tags: 'Etiquetas',
    tax: 'Impuesto',
    tax_regime: 'Regimen tributario',
    tax_responsibility: 'Responsabilidad fiscal',
    taxes: 'Impuestos',
    taxpayer_identification_number: 'Número de identificación tributaria',
    technician: 'Técnico',
    technician_read_only: 'Técnico de solo lectura',
    technician_supervisor: 'Supervisor técnico',
    technician_supervisor_read_only: 'Supervisor técnico de solo lectura',
    telegram: 'Telegram',
    telegram_quantity: 'Cantidad de Telegram',
    template: 'Template',
    terms_and_conditions: 'Términos y Condiciones',
    the_acs_service_is_disabled: 'El servicio de ACS esta deshabilitado',
    the_acs_service_is_enabled: 'El servicio de ACS esta habilitado',
    the_nas_service_is_disabled: 'El servicio de NAS se encuentra deshabilitado',
    the_nas_service_is_enabled: 'El servicio de NAS se encuentra habilitado',
    the_number_of_linked_nas_is_counted: 'se cuenta el número de NAS vinculados',
    the_radius_service_is_disabled: 'El servicio de radius se encuentra deshabilitado',
    the_radius_service_is_enabled: 'El servicio de radius se encuentra habilitado',
    this_device_does_not_support_wi_fi_configuration: 'Configuración no soportada por el dispositivo',
    three_months: 'Consumo de los ultimos 3 meses',
    ticket: 'Ticket',
    ticket_id: 'Ticket ID',
    ticket_lost: 'Ticket perdido',
    ticket_number: 'Número de ticket',
    tickets: 'Tickets',
    time_zone: 'Huso Horario',
    title: 'Título',
    to_be_invoiced: 'A facturar',
    to_create_the_contract: 'Para crear el contrato haga clic aquí',
    to_disable: 'Deshabilitar',
    to_enable: 'Habilitar',
    to_reschedule: 'Reprogramar',
    to_send: 'Por enviar',
    today: 'Hoy',
    tolerance: 'Tolerancia',
    total: 'Total',
    total_amount: 'Monto Total',
    total_items: 'Total items',
    total_lapses: 'Periodos totales',
    total_nas_linked: 'Total de NAS vinculados',
    total_paid: 'Total pagado',
    total_records: 'Registros totales',
    total_to_avoid: ' Total a anular',
    trace_route: 'Traceroute',
    traffic: 'Consumo',
    traffic_control: 'Control de tráfico',
    transaction: 'Transacción',
    transaction_already_exist: 'Transacción ya existe',
    transaction_amount: 'Monto de la transacción',
    transaction_code: 'Código de transacción',
    transaction_details: 'Detalles de transacción',
    transaction_id: 'Código de transacción',
    transaction_number: 'Número de transacción',
    transaction_value: 'Valor de la Transacción',
    transactions: 'Transacciones',
    transmitting_data: 'Transmitiendo datos',
    trial_due: 'Vencimiento de días free',
    trial_duration: 'Duración del periodo gratuito',
    trial_expiration_date: 'Periodo gratuito',
    trial_used: 'Periodo gratuito finalizado',
    trialing: 'En periodo gratuito',
    try_again: 'Inténtelo de nuevo',
    try_again_or_contact_support: 'Intente nuevamente o contacte con soporte.',
    type: 'Tipo',
    unauthorize: 'Desautorizar',
    unauthorized: 'No autorizado',
    uncheck: 'Desverificar',
    under_construction: 'En construcción',
    unexpected_error_getting_data: 'Error inesperado al obtener el {{model}}',
    unidentified: 'No identificado',
    unique_transaction_code: 'Código único de transacción',
    unit: 'Unidad',
    unit_price: 'Precio Unitario',
    unknown: 'Desconocido',
    unlock: 'Desbloquear',
    unpaid: 'Impago',
    unpaid_bills: 'Facturas impagas',
    unpaid_invoices: 'Facturas Impagas',
    unsubscribe: 'Cancelar suscripción',
    unsubscribe_subscription: 'Dar de baja',
    until: 'Hasta',
    unverified: 'Sin Verificar',
    unviewed: 'No visto',
    up_to_date: 'Al día',
    update: 'Actualizar',
    update_certificate: 'Subir Certificado',
    update_date: 'Fecha actualización',
    update_payments_gateway: 'Actualizar pasarela de pagos',
    updated_at: 'Actualizado el',
    upload_afip_certificate: ' Subir el certificado otorgado por afip',
    uploading: 'Subiendo',
    uploading_file: 'Subiendo archivo',
    use_contract_form: 'Usar formulario de contratos',
    use_wispro_sstp: 'Usar Wispro VPN',
    user: 'Usuario',
    user_id: 'Usuario (ID)',
    user_locked: 'Usuario bloqueado',
    user_responsible: 'Usuario responsable',
    username: 'Nombre de usuario',
    users: 'Usuarios',
    uzera: 'Uzera',
    validate_data: 'Validar datos',
    vat_condition: 'Condición de IVA',
    verified: 'Verificado',
    verified_by_support: 'Verificado por soporte',
    verified_client: 'Cliente verificado',
    verify: 'Verificar',
    verify_by_support: 'Verificar por soporte',
    verify_file: 'Verificar archivo',
    verify_webservice_connection: 'Verificar conexión con webservice',
    verifying: 'Verificando',
    version: 'Versión',
    view_billing_transactions: 'Ver movimientos de facturación',
    view_client: 'ver Cliente',
    view_details: 'Ver detalles',
    view_invoice_details: 'Ver detalles de factura',
    view_link: 'Ver enlace',
    view_new_changes: 'Explora lo nuevo',
    viewed: 'Visto',
    vippo: 'ViPPO',
    virtual_agent: 'Agente virtual',
    vlan: 'VLAN',
    void: 'Anulada',
    //--> void no es anulada.
    voided: 'Anulada',
    voucher: 'Comprobante',
    wan_configuration: 'Configuración WAN',
    warning: 'Advertencia',
    watch_video: 'Ver video',
    web_port: 'Puerto Web',
    webservice_info: 'Información del webservice',
    week: 'Semana',
    week_control: 'Control semanal',
    whatsapp: 'Whatsapp',
    where: 'Dónde',
    wifi: 'Wi-Fi',
    wifi_configuration: 'Configuración Wi-Fi',
    will_deleted_one: 'Se borrará',
    will_deleted_other: 'Se borrarán',
    will_unlink_plural: 'Se desvincularán',
    will_unlink_singular: 'Se desvinculará',
    will_update_verb: 'Se Actualizará',
    will_updates_verb: 'Se Actualizarán',
    winbox_port: 'Puerto Winbox',
    wispbot_initial_message: 'Hola, quiero hacerte una pregunta',
    wispro_automatically: 'Wispro (Automáticamente)',
    wispro_automatically_unaccent: 'Wispro (Automaticamente)',
    wispro_box: 'WisproBox',
    wispro_cloud: 'Wispro Cloud',
    wispro_migration: 'Migración Wispro',
    wispro_system: 'Wispro (sistema)',
    with: 'Con',
    with_payment_gateways: 'Con todas las pasarelas de pago',
    without: 'Sin',
    without_changes: 'Sin cambios',
    without_neighborhoods: 'Sin Barrios',
    without_payment_gateways: 'Sin pasarelas de pago',
    without_permissions: 'Sin permisos',
    without_taxpayer_identification_number: 'Sin número de identificación tributaria',
    without_zones: 'Sin Zonas',
    wompi: 'Wompi',
    write_comment: 'Escriba su comentario...',
    year: 'Año',
    years: 'Años',
    yes: 'Si',
    you_can_search_by: 'Puede buscar por',
    zip_code: 'Código postal',
    zone: 'Zona',
    zones: 'Zonas',
    zoom_in: 'Acercar',
    zoom_out: 'Alejar'
  }
};
